/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { Brands } from '@/lib/constants';
import { PublicConfig } from '@/types/app-config';

const seo: PublicConfig['seo'] = {
  [Brands.MAYORAL]: {
    titleTemplate: '%s - Mayoral Workshops',
    defaultTitle: 'Mayoral Workshops',
    additionalMetaTags: [
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0',
      },
    ],
    additionalLinkTags: [
      {
        rel: 'shortcut icon',
        type: 'image/png',
        href: `/images/mayoral/icon.svg`,
      },
    ],
  },
  [Brands.BOSTON]: {
    titleTemplate: '%s - Boston Workshops',
    defaultTitle: 'Boston Workshops',
    additionalMetaTags: [
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0',
      },
    ],
    additionalLinkTags: [
      {
        rel: 'shortcut icon',
        type: 'image/png',
        href: `/images/boston/favicon.ico`,
      },
    ],
  },
  [Brands.HUGANDCLAU]: {
    titleTemplate: '%s - Hug&Clau Workshops',
    defaultTitle: 'Hug&Clau Workshops',
    additionalMetaTags: [
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0',
      },
    ],
    additionalLinkTags: [
      {
        rel: 'shortcut icon',
        type: 'image/png',
        href: `/images/hugandclau/favicon.ico`,
      },
    ],
  },
  [Brands.ABELANDLULA]: {
    titleTemplate: '%s - Abel & Lula Workshops',
    defaultTitle: 'Abel & Lula Workshops',
    additionalMetaTags: [
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0',
      },
    ],
    additionalLinkTags: [
      {
        rel: 'shortcut icon',
        type: 'image/png',
        href: `/images/${Brands.ABELANDLULA}/favicon.ico`,
      },
    ],
  },
};

export default seo;
